import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import { Icon } from '../Icon';

interface SidebarButtonProps {
  onClick?: () => void;
  isOpen?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

const Layout = styled.button<SidebarButtonProps>`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  width: ${toRem(20)};
  height: ${toRem(20)};
  margin-right: ${toRem(8.75)};
  transform: rotateZ(180deg);

  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: rotateZ(0);
    `}

  @media (min-width: ${theme.breakpoint.large}px) {
    display: none;
  }
`;

const SidebarButton: React.FC<SidebarButtonProps> = ({ onClick, isOpen, className, type = 'button' }) => (
  <Layout type={type} onClick={onClick} isOpen={isOpen} className={className}>
    <Icon icon="Dropdown" width={20} height={20} fill={theme.color.neutral[900]} />
  </Layout>
);

export default SidebarButton;
